import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  handleFrameMissing(event){

  }

  // event => turbo:submit-end
  next(event) {
    if (event.detail.success) {
      console.log("SUCCESS", event);
      // return false
      // //event.stopPropagation();

      // const fetchResponse = event.detail.fetchResponse;

      // history.pushState(
      //   { turbo_frame_history: true },
      //   "",
      //   fetchResponse.response.url
      // );

      //Turbo.visit(fetchResponse.response.url);
      // return false;
    }
  }
}
